<div class="record-actions"></div>
<div class="header-group-dropdown" *ngIf="showGroup"></div>
<div class="record-confidentiality" *ngIf="confidentialityTmpl">
  <span class="header confidentiality">
    {{ 'template.reportViewState' | xTranslate | uppercase }}
  </span>
</div>
<div class="header-cell">
  <div *ngFor="let field of allFields; let index = index">
    <span class="compare-cell header-cell name">{{ field.label }}</span>
  </div>
</div>
